import { render, staticRenderFns } from "./QuickEdit.vue?vue&type=template&id=3bb634a3&lang=pug&"
import script from "./QuickEdit.vue?vue&type=script&lang=js&"
export * from "./QuickEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports